import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AventuraService } from 'src/app/services/api/aventura.service';
import { FileService } from 'src/app/services/api/file.service';
import { FunctionsService } from 'src/app/services/api/functions.service';
import { CognitoService } from 'src/app/services/cognito.service';
import {
  getProgrammingLocacion,
  getProgrammingProvider,
  getProgrammingProviderId
} from 'src/entities/file/model/programming-service';
import { providerInfo } from 'src/features/file-services/manage-provider/ui/dialog-provider/dialog-provider.component';

@Component({
  selector: 'app-dialog-service',
  templateUrl: './dialog-service.component.html',
  styleUrls: ['./dialog-service.component.css']
})
export class DialogServiceComponent implements OnInit {
  providerList: providerInfo[] | null = null;
  idProvider: string = '';
  isLoading: boolean = false;
  newService: any = '';
  nombreProveedor: string | null = null;
  servicesList: any[] | null = null;
  isLoadingResult: boolean = false;
  messageResult: string | null = null;
  iconResult: boolean | null = null;
  showModal: boolean = false;
  nombreProvedor: string = '';
  user: string | null = null;

  stateProvedorCmb: boolean = false;
  newProvider: any = '';
  tipoServicio: string = '';
  categoriaServicio: string = '';
  locacion: string = '';
  providerId: string = '';

  filteredServices: any[] | null = null;

  constructor(
    public dialogRef: MatDialogRef<DialogServiceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: AventuraService,
    private fileService: FileService,
    private functions: FunctionsService,
    public Cognito: CognitoService
  ) {}

  ngOnInit(): void {
    this.nombreProvedor = getProgrammingProvider(this.data?.oldService)?.nombre ?? '';
    this.tipoServicio = this.data.oldService.tipoServicio;
    this.categoriaServicio = this.data.oldService.categoriaServicio;
    this.locacion = getProgrammingLocacion(this.data.oldService) ?? '';
    this.providerId = getProgrammingProviderId(this.data.oldService) ?? '';
    const dateItinerary = this.convertDateToISO(this.data.oldService.dateRange);
    const dateFile = {
      fechaInicio: dateItinerary || '',
      fechaFin: ''
    };

    this.getServicesByType(
      this.data.tipo,
      this.categoriaServicio,
      this.providerId,
      this.locacion,
      this.providerId,
      dateFile
    );

    /*     this.Cognito.getUser().then((value) => {
      this.user = value.attributes.email;
    }); */

    this.user = localStorage.getItem('email');
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  filterServices(query: string): void {
    const queryString = typeof query === 'string' ? query.toLowerCase() : '';
    this.filteredServices =
      this.servicesList?.filter((service) => {
        return service.nombreServicio.toLowerCase().includes(queryString);
      }) ?? [];

    // Ordenar alfabéticamente
  }

  getServicesByType(
    tipo: string,
    categoria: string,
    id: string,
    locacion: string,
    providerId: string,
    dateVigencia: any
  ) {
    this.isLoading = true;

    const categoria_ = categoria ? categoria : '';
    const locacion_ = locacion ? locacion : '';

    const processServices = (services: any[]) => {
      // Filtrar servicios que cumplan todos los criterios
      const filteredServices = services.filter(
        (srv: any) =>
          srv.locacion === locacion &&
          srv.servicioProveedorId === providerId &&
          srv?.tarifa &&
          srv.nombreServicio !== this.data.nombreServicio
      );

      // Obtener nombres únicos de servicios
      const uniqueNames = [
        ...new Set(filteredServices.map((item: any) => item.nombreServicio))
      ];

      // Crear array con un servicio por nombre único
      const array: any[] = [];
      uniqueNames.forEach((name) => {
        const service = filteredServices.find(
          (srv: any) => srv.nombreServicio === name
        );
        if (service) {
          array.push(service);
        }
      });

      // Ordenar por locación y luego por nombre de servicio
      array.sort((a, b) => {
        if (a.locacion === b.locacion) {
          return a.nombreServicio?.localeCompare(b.nombreServicio);
        }
        return a.locacion?.localeCompare(b.locacion);
      });

      this.servicesList = array;
      this.filteredServices = array;
      this.isLoading = false;
    };

    console.log({ tipo, categoria_, dateVigencia });

    if (!this.nombreProvedor?.toUpperCase().includes('EXPLORANDES')) {
      this.service
        .getAllServicesByTypeAndProvider(
          tipo,
          categoria_,
          id,
          locacion_,
          dateVigencia
        )
        .subscribe((result) => {
          processServices(result.getAllServicesByTypeAndProvider || []);
        });
    } else {
      this.service
        .getAllServicesByType(tipo, categoria_, dateVigencia, true)
        .subscribe((result) => {
          console.log('result', result);
          processServices(result.getAllServicesByType || []);
          console.log('array', this.servicesList);
        });
    }
  }

  getProviders(
    nombreServicio: String,
    categoriaServicio: String,
    locacion: String
  ) {
    this.isLoading = true;
    this.fileService
      .getProvidersByService(
        String(nombreServicio || ''),
        String(categoriaServicio || ''),
        String(locacion || '')
      )
      .subscribe({
        next: (envelope) => {
          const rows = envelope?.data ?? [];
          this.providerList = rows.filter(
            (item: any) => item.nombre !== this.data.nombreProveedor
          ) as providerInfo[];
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Error getProvidersByService', err);
          this.providerList = [];
          this.isLoading = false;
        }
      });
  }

  saveChangeServices() {
    this.isLoadingResult = true;

    const newServiceOrder: any = {
      ...this.newService,
      tarifa: { ...this.newService.tarifa?.[0] }
    };

    const service = {
      id: this.data.oldService.id,
      itineraryId: this.data.idItinerary,
      nombreItinerario: this.data.oldService.nombreItinerario,
      fileName: this.data.oldService.fileName,
      fileNumber: this.data.oldService.fileNumber,
      serviceId: this.newService.id,
      productId: this.data.oldService.productId,
      providerId: this.newProvider.id,
      tarifaId: newServiceOrder.tarifa.id,
      day: this.data.oldService.day,
      price: Number(this.getPrice(newServiceOrder)),
      costo: Number(this.getCosto(newServiceOrder)),
      utilidad: Number(this.newService.tarifa[0]?.utilidad),
      margen: Number(
        (
          this.getPrice(newServiceOrder) - this.getCosto(newServiceOrder)
        )?.toFixed(2)
      ),
      cantPersonal: Number(this.data.oldService.cantPersonal),
      tipoServicio: this.newService.tipoServicio,
      tipoMoneda: this.newService.tarifa[0]?.monedaTarifa,

      totalPriceSoles:
        this.getMonedaTarifa(newServiceOrder) === 'S'
          ? this.getPax(this.data.oldService)
            ? Number(
                (
                  this.getPax(this.data.oldService) *
                  this.getPrice(newServiceOrder)
                )?.toFixed(2)
              )
            : Number(
                (
                  this.getNroPasajero(this.data.oldService) *
                  this.getPrice(newServiceOrder)
                )?.toFixed(2)
              )
          : null,

      totalPriceDolares:
        this.getMonedaTarifa(newServiceOrder) === 'S'
          ? this.isPorratea(newServiceOrder)
            ? Number(this.getPrice(newServiceOrder)?.toFixed(2))
            : this.getPax(this.data.oldService)
              ? Number(
                  (
                    (this.getPax(this.data.oldService) *
                      this.getPrice(newServiceOrder)) /
                    this.data.oldService.tipoCambio
                  )?.toFixed(2)
                )
              : Number(
                  (
                    (this.getNroPasajero(this.data.oldService) *
                      this.getPrice(newServiceOrder)) /
                    this.data.oldService.tipoCambio
                  )?.toFixed(2)
                )
          : this.getMonedaTarifa(newServiceOrder) === 'D'
            ? this.isPorratea(newServiceOrder)
              ? Number(this.getPrice(newServiceOrder)?.toFixed(2))
              : this.getPax(this.data.oldService)
                ? Number(
                    (
                      this.getPax(this.data.oldService) *
                      this.getPrice(newServiceOrder)
                    )?.toFixed(2)
                  )
                : Number(
                    (
                      this.getNroPasajero(this.data.oldService) *
                      this.getPrice(newServiceOrder)
                    )?.toFixed(2)
                  )
            : 0,

      nombreServicio: this.newService.nombreServicio,
      observaciones: this.data.oldService.observaciones,
      categoriaServicio: this.newService.categoriaServicio,
      lstPaX: this.data.oldService.lstPaX,
      numReserva: this.data.oldService.numReserva,
      estadoReserva: this.data.oldService.estadoReserva,
      numOS: this.data.oldService.numOS
    };

    this.fileService
      .changeService(
        this.data.idRegistro,
        service,
        this.user ? this.user.toString() : ''
      )
      .subscribe({
        next: (result) => {
          if (result?.changeService) {
            this.iconResult = true;
            this.messageResult = 'Servicio Actualizado';
          } else {
            this.messageResult = 'Ocurrio un Error';
            this.iconResult = false;
          }
        },
        error: (err) => {
          this.iconResult = false;
          this.messageResult = 'Ocurrio un Error';

          this.isLoadingResult = false;
          setTimeout(() => {
            this.dialogRef.close();
            // this.iconResult = null
          }, 2000);
        },

        complete: () => {
          this.showModal = true;
          this.isLoadingResult = false;

          this.functions.disparadorCambios.emit(this.data.secction);

          setTimeout(() => {
            this.dialogRef.close();
            this.showModal = false;
          }, 2000);
        }
      });
  }

  getCosto = (item: any) => {
    const result =
      item.tarifa?.tarifaDia && item.tarifa?.tipoPax === 'PRORRATEA'
        ? item.tarifa?.tarifaDia
        : item.tarifa?.tarifaDia && item.tarifa?.tipoPax === 'PAX'
          ? item.tarifa?.tarifaDia
          : 0;

    return result;
  };

  getPrice = (item: any) => {
    const result =
      item.tarifa?.tarifaDia && item.tarifa?.tipoPax === 'PRORRATEA'
        ? item.tarifa?.tarifaDia * (item.tarifa?.utilidad + 1)
        : item.tarifa?.tarifaDia && item.tarifa?.tipoPax === 'PAX'
          ? item.tarifa?.tarifaDia * (item.tarifa?.utilidad + 1)
          : 0;

    return result;
  };

  getMonedaTarifa = (item: any) => {
    const result =
      item.tarifa?.monedaTarifa === 'S' || item.tarifa?.monedaTarifa === 'SOL'
        ? 'S'
        : item.tarifa?.monedaTarifa === 'D' ||
            item.tarifa?.monedaTarifa === 'DOLAR'
          ? 'D'
          : null;

    return result;
  };
  getNroPasajero = (item: any) => {
    const result = item.lstPaX?.filter((x: any) => x?.['estado']);

    return result?.length;
  };

  isPorratea = (item: any) => {
    const result =
      item.tarifa?.tarifaDia && item.tarifa?.tipoPax === 'PRORRATEA'
        ? true
        : false;

    return result;
  };

  getPax = (item: any) => {
    const result = item.cantPersonal
      ? this.getNroPasajero(item) > 0
        ? item.nroPersonasPax?.[this.getNroPasajero(item) - 1]?.numPax
        : null
      : null;

    return result;
  };

  onChange(event: any): void {
    if (
      event &&
      event.nombreServicio &&
      event.categoriaServicio &&
      event.locacion
    ) {
      this.getProviders(
        event.nombreServicio,
        event.categoriaServicio,
        event.locacion
      );
      this.stateProvedorCmb = true;
    } else {
      console.error('Datos incompletos en el evento:', event);
    }
  }

  getOptionText(service: any): string {
    return service && service.nombreServicio ? service.nombreServicio : '';
  }
  convertDateToISO(dateStr: string) {
    if (!dateStr) return null;
    const dateSplit =
      dateStr?.split('-').length > 1 ? dateStr.split('-')[0] : dateStr;
    const [day, month, year] = dateSplit?.split('/')?.map(Number);
    const date = new Date(year, month - 1, day);

    return date?.toISOString();
  }
}
